const EN_CONTENT = Object.freeze({ model: 'M0' })

const ZH_CONTENT = Object.freeze({
  model: 'P0',
  heroSubtitle: '专业智能体测仪',
  scrollLabel: '滚动鼠标',
  functionsKicker: '功能',
  functionsTitle: '人体成分分析',
  functionsCount: '32',
  metrics: ['身高', '体重', 'BMI', '体脂率', '肌肉率', '人体水分', '内脏脂肪'],
  screenValue: '10.1',
  screenUnit: '英寸',
  screenTitle: '无边框触摸屏',
  screenDescription: '健康数据采用图表展示，可一眼读取结果。',
  baseTitle: '悬浮底座',
  baseDescription: '悬浮圆角钢化玻璃，机身纤薄，简约时尚',
  seamlessTitle: '一体成型，无缝工艺',
  lightTitle: '点睛之笔',
  lightDescription: '家用灯带，颜值出彩',
  sensorTitle: '水平波传感器',
  sensorDescription: '可精确测量人体重量（精度至克）以及欧姆级电阻率变化，保障测量结果的精准性与稳定性。',
  afterSalesTitle: '售后支持服务',
  afterSalesLead: '精准的数据采集仅仅是开端',
  requestDemo: '申请演示',
  activationTitle: '全新激活模块',
  activationDescription: '这份便捷伴随着全面的可追溯性，无论是用户追溯多年的生产信息，还是经销商为企业精准管理设备，每一台体测仪的“生平”都清晰可查，我们相信，极致的便捷与严谨的管理，本可兼得。',
  cloudKicker: '系统',
  cloudTitle: 'ATLAS多模态医疗AI大数据云计算平台',
  cloudName: 'ANOVATOR云',
  cloudDescription: '以 ANOVATOR 云为中心，连接实时数据采集、AI 深度训练、反哺应用迭代三个模块，形成闭环运作；下方横向流程节点依次为市场洞察、技术开发、数据融合、算法集群、实时决策',
  adminKicker: '系统',
  adminTitle: '源诺医疗智能管理后台',
  adminSubtitle: '记录健康也统管设备',
  adminCards: [
    { title: '软件平台 全程追溯', description: '你可以随时查看单一设备的出厂日期、地点、所属等信息，设备因此有了记忆，让你的每一次追溯，都有迹可循。' },
    { title: '云端配置 瞬时部署', description: '针对大型连锁机构的批量订单，可通过云平台进行统一配置与管理，极大提升部署与运维效率。' }
  ],
  disclaimerTitle: '特别声明：',
  disclaimer: [
    '以上页面中的产品图片及屏幕内容仅作示意，产品实际外观（包括但不限于颜色、尺寸、设计细节）与显示内容（包括但不限于背景、界面、图形效果）可能存在差异，一切请以实物为准。',
    '以上页面所呈现的全部数据，均为 ANOVATOR 或其合作实验室在特定测试条件下（详见各单项说明）通过内部测试得出的理论值。受产品个体差异、软件版本、使用条件及环境因素影响，实际使用效果可能有所不同，一切请以实际使用情况为准。',
    '为尽可能提供准确的产品信息、规格及功能，ANOVATOR 可能会对以上页面中的文字说明、图片等内容进行实时调整与修订，确保与产品实际性能、规格、指标及部件保持一致。因产品批次及供货条件变化，此类修改可能不会提前另行通知。'
  ]
})

function getM0ProductContent(language) {
  return language === 'ZH' ? ZH_CONTENT : EN_CONTENT
}

module.exports = { EN_CONTENT, ZH_CONTENT, getM0ProductContent }
